import React, { createContext, PropsWithChildren, useEffect, useState } from "react";
import { Application, TenantApi } from "../api";
import { generateTenantConfig } from "./tenant-context-utils";
import { TenantContextValue, tenantDefaultContextValue } from "./domain";

export const TenantContext = createContext<TenantContextValue>(tenantDefaultContextValue);

export interface TenantProviderProps {
  callbackFn?: (config: TenantContextValue) => void;
  application: Application;
  children?: React.ReactNode;
}

export const TenantProvider: React.FC<PropsWithChildren<TenantProviderProps>> = ({
  callbackFn,
  application,
  children
}) => {
  const [configuration, setConfiguration] = useState<TenantContextValue>();

  useEffect(() => {
    TenantApi.getTenants(application).then(async (ts) => {
      setConfiguration(await generateTenantConfig(ts, callbackFn));
    });
  }, [callbackFn, application]);

  return (
    (configuration && (
      <TenantContext.Provider value={configuration}>{children}</TenantContext.Provider>
    )) ||
    null
  );
};
